import React from 'react';
import '../CSS/Profile/JessicaThompsonProfile.css';

const JessicaThompsonProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/jessica-thompson-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Jessica Thompson"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Jessica Thompson</h1>
        <div className="profile-title-container">
          <p className="profile-title">Associate Vice President and Executive Search Coordinator</p>
          <a href="https://www.linkedin.com/in/jessica-thompson-88a1b7132/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            Jessica Thompson serves as Associate Vice President and Executive Search Coordinator. She is responsible for overseeing the firm's proprietary database and ensuring information is updated and accurate. She works closely with consultants to provide information and materials throughout the search process.
          </p>
          <p>
            Mrs. Thompson brings extensive experience in customer service, computer technology, and operations management to her position. Previously she served five years as Operations Manager for Kay-Lynn LLC in Macon, Georgia, overseeing the day-to-day operations and handling customer service needs.
          </p>
          <p>
            Earlier in her career, Mrs. Thompson was an Archival Assistant at the Georgia Sports Hall of Fame. She also was a Docent at The Old Governor's Mansion in Milledgeville, Georgia, and a Senior Docent at The Johnston-Felton-Hay Historic Property in Macon. In each of these positions she assisted with the day-to day operations and handled requests and questions from visitors.
          </p>
          <p>
            Mrs. Thompson holds a Bachelor of Arts degree in History from the University of North Alabama. Additionally, she has taken graduate coursework in Business Administration at the University of North Alabama and in Public History, specifically Historic Site and Archival Management, at Georgia College and State University.
          </p>
        </div>
      </div>
    </div>
  );
};

export default JessicaThompsonProfile;

